import React from 'react';

const SITUATIONS = [
  'Food & Coffee',
  'Doctor visits',
  'Hair salon',
  'Banking',
  'Phone calls',
  'Shopping',
  'Work conversations',
  'Travel',
  'Customer support',
  'Returns & refunds',
  'Appointments',
  'Small talk',
];

export default function Situations() {
  return (
    <section id="situations" className="section">
      <h2 className="section__title">Practice English for real situations</h2>
      <div className="chip-row">
        {SITUATIONS.map((s) => (
          <span className="chip" key={s}>{s}</span>
        ))}
      </div>
    </section>
  );
}
